import {
  Button,
  Flex,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Text,
} from '@chakra-ui/react'
import { PropsWithChildren, ReactNode, useMemo } from 'react'

const getStatusColor = (complete: boolean) => {
  if (complete) {
    return 'green'
  }
  return 'gray'
}

export const SignOnStatusItem = ({
  label,
  complete,
  icon,
  children,
  popoverWidth,
}: PropsWithChildren<{
  label: string
  complete: boolean
  icon?: ReactNode
  popoverWidth?: string
}>) => {
  const color = useMemo(() => getStatusColor(complete), [complete])
  const content = (
    <>
      {icon}
      <Text fontSize="sm" fontWeight={600} color={`${color}.800`}>
        {label}
      </Text>
      {complete ? (
        <Text ml="auto" fontSize="sm" fontWeight={600} color={`${color}.800`}>
          ✓
        </Text>
      ) : null}
    </>
  )

  if (!children)
    return (
      <Flex align="center" minH={8} py={1} borderRadius={6} bg={`${color}.300`} px={3} gap={2}>
        {content}
      </Flex>
    )

  return (
    <Popover closeOnBlur={false} trigger="hover" placement="bottom" strategy="fixed">
      <PopoverTrigger>
        <Button
          size="sm"
          bg={`${color}.300`}
          justifyContent="flex-start"
          color={`${color}.800`}
          _hover={{
            bg: `${color}.400`,
          }}>
          {content}
        </Button>
      </PopoverTrigger>
      <PopoverContent w="auto">
        <PopoverBody w={popoverWidth}>{children}</PopoverBody>
        <PopoverArrow />
      </PopoverContent>
    </Popover>
  )
}
